module.exports =
  'COMMONHEADER':
    'NEWS': 'Magazine'
    'LOGOUT': 'Log out'
    'MYSCOREBOOK': 'My ScoreBook'
    'FAQ': 'FAQ'
  'TERMS_OF_USE':
    'TITLE': 'Request for Agreement to Terms of Use and Privacy Policy'
    'BODY_1': 'The contents of the Terms of Use and Privacy Policy have been updated.'
    'BODY_2': 'Please review and agree to the updated terms before continuing to use the service.'
    'BODY_3': '※Please make sure to click the links below and review the contents on the linked pages.'
    'LINK_TERMS': 'Terms of Use'
    'LINK_PRIVACY': 'Privacy Policy'
    'CHECKBOX': 'I agree to the separate consent items regarding the use of personal information'
    'BUTTON': 'Continue using the service'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-header/i18n/en.coffee